<template>
  <div
    class="page-plp_product__lp-item"
    :class="{ 'page-plp_product_mobile__item': isMobile }"
    :style="elementStyle"
  >
    <!--  -->
    <PdtCornerLabel abs-position :data="tagName" class="tag" style="z-index: 1" />
    <nuxt-link
      v-if="!isMobile"
      :to="{
        name: 'pdp',
        params: { code: activeData.productNo },
        query: {}
      }"
      target="_blank"
      :module_name="activeData.operationData && activeData.operationData.module_name"
      :module_rank="activeData.operationData && activeData.operationData.module_rank"
      :operation_name="activeData.operationData && activeData.operationData.operation_name"
      :operation_id="activeData.operationData && activeData.operationData.operation_id"
      :operation_rank="activeData.operationData && activeData.operationData.operation_rank"
      :destination_url="activeData.operationData && activeData.operationData.destination_url"
      click_type="商品"
      :event_name="event"
      :expose_type="'手动切换'"
      :product_rank="activeData.operationData && activeData.operationData.product_rank"
      :primary_category="activeData.operationData && activeData.operationData.primary_category"
      :secondary_category="activeData.operationData && activeData.operationData.secondary_category"
      :third_category="activeData.operationData && activeData.operationData.third_category"
      :activity_attribute="
        JSON.stringify(activeData.operationData && activeData.operationData.activity_attribute)
      "
      :gender="activeData.operationData && activeData.operationData.gender"
      :spu_id="activeData.operationData && activeData.operationData.spu_id"
      :spu_name="activeData.operationData && activeData.operationData.spu_name"
      :sales_price="activeData.operationData && activeData.operationData.sales_price"
      :list_price="activeData.operationData && activeData.operationData.list_price"
      :button_name="activeData.operationData && activeData.operationData.button_name"
    >
      <div class="lp-item__image-wraper">
        <UAImage
          aspect-ratio="4 / 5"
          class="lp-item__image lp-item__image-front"
          :src="displayImageList[0]"
          :alt="activeData.productName"
        />
        <UAImage
          v-if="defer(1) && displayImageList[1]"
          aspect-ratio="4 / 5"
          class="lp-item__image lp-item__image-back"
          :src="displayImageList[1]"
          :alt="activeData.productName"
        />
      </div>
    </nuxt-link>

    <nuxt-link
      v-else
      :to="{
        name: 'pdp',
        params: { code: activeData.productNo },
        query: {}
      }"
      target="_blank"
      :module_name="activeData.operationData && activeData.operationData.module_name"
      :module_rank="activeData.operationData && activeData.operationData.module_rank"
      :operation_name="activeData.operationData && activeData.operationData.operation_name"
      :operation_id="activeData.operationData && activeData.operationData.operation_id"
      :operation_rank="activeData.operationData && activeData.operationData.operation_rank"
      :destination_url="activeData.operationData && activeData.operationData.destination_url"
      click_type="商品"
      :event_name="event"
      :expose_type="'手动切换'"
      :product_rank="activeData.operationData && activeData.operationData.product_rank"
      :primary_category="activeData.operationData && activeData.operationData.primary_category"
      :secondary_category="activeData.operationData && activeData.operationData.secondary_category"
      :third_category="activeData.operationData && activeData.operationData.third_category"
      :activity_attribute="activeData.operationData && activeData.operationData.activity_attribute"
      :gender="activeData.operationData && activeData.operationData.gender"
      :spu_id="activeData.operationData && activeData.operationData.spu_id"
      :spu_name="activeData.operationData && activeData.operationData.spu_name"
      :sales_price="activeData.operationData && activeData.operationData.sales_price"
      :list_price="activeData.operationData && activeData.operationData.list_price"
      :button_name="activeData.operationData && activeData.operationData.button_name"
      style="width: 100%"
    >
      <UAImage
        aspect-ratio="4 / 5"
        :src="activeData && activeData.mediaLinkList && activeData.mediaLinkList[0]"
        :alt="activeData.productName"
      />
    </nuxt-link>
    <div class="spu-list">
      <div v-if="!isMobile && defer(2)" class="hover-box">
        <GtSwiper
          v-if="spuColor.length > 1"
          :data="productList || []"
          :swiper-option="swiperOption"
          :hidden-button="spuColor.length < thumbnailNum"
          class="product-preview-mini-img-swiper"
        >
          <div slot="default" slot-scope="{ data }" class="swiper-detail">
            <nuxt-link
              :to="{
                name: 'pdp',
                params: { code: data.productNo },
                query: {}
              }"
              target="_blank"
            >
              <div @mouseenter.stop="handleSelectProduct(data)">
                <UAImage
                  :src="data.mediaLinkList && data.mediaLinkList.length && data.mediaLinkList[0]"
                  :alt="data.productName"
                  aspect-ratio="4 / 5"
                />
                <!-- <span v-if="data.inStock === 0" class="out-of-stock">补货中</span> -->
                <div
                  v-if="activeData.productCode == data.productCode"
                  class="active-border-bottom-line"
                ></div>
              </div>
            </nuxt-link>
          </div>
          <div v-if="spuColor.length > 5" slot="pagination">
            <div class="swiper-button-prev">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15 6L9 12L15 18"
                  stroke="#14141E"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <div class="swiper-button-next">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9 18L15 12L9 6"
                  stroke="#14141E"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
        </GtSwiper>
      </div>
    </div>
    <div class="sp-plp-card__name">
      <p class="product-name one-line">
        {{ activeData.productName || data.productName }}
      </p>
    </div>
    <div
      v-if="
        isShowFFSPriceFlag &&
        getFFsPriceC.isShowFFSPrice &&
        !['home', 'LandingPage'].includes($route.name)
      "
      class="sp-lp-card__final-price"
    >
      <div class="sp-lp-card__final-price-left">
        <div class="sale-price">{{ data.salePrice | $PriceFloat }}</div>
        <div class="final-price-text">内购价</div>
      </div>
      <div class="product-price">{{ getFFsPriceC.ffsPrice | $PriceFloat }}</div>
    </div>
    <div v-else>
      <div
        v-if="!getFinalPriceC.isShowFinalPrice || $route.name === 'home'"
        class="sp-plp-card__price"
      >
        <p>
          <span
            v-if="data.salePrice"
            class="sale-price"
            :class="{ 'is-line-through': data.productPrice != data.salePrice }"
          >
            {{ data.salePrice | $PriceFloat }}
          </span>
          <span v-if="data.productPrice != data.salePrice" class="product-price">
            {{ data.productPrice | $PriceFloat }}
          </span>
        </p>
      </div>
      <div v-else-if="showFinalPrice" class="sp-lp-card__final-price">
        <div class="sp-lp-card__final-price-left">
          <div class="sale-price">{{ data.salePrice | $PriceFloat }}</div>
          <div class="final-price-text">预估到手价</div>
        </div>
        <div class="product-price">{{ getFinalPriceC.finalPrice | $PriceFloat }}</div>
      </div>
    </div>
    <div v-if="data.salePoint" class="sp-lp-card__salePoint">
      <span>{{ data.salePoint }}</span>
    </div>
  </div>
</template>

<script>
import { GtSwiper, componentsCommon } from '@speedshop/template';
import PdtCornerLabel from '@/components/PDP/PdtCornerLabel.vue';
import UAImage from '@/components/UAImage/index.vue';
import { getFinalPrice, getFFsPrice } from '@/utils/pdp';
import { isVideoType } from '@/utils/tools';
import defer from '@/mixins/defer';

export default {
  components: { UAImage, GtSwiper, PdtCornerLabel },
  mixins: [componentsCommon, defer()],
  props: {
    data: {
      type: Object
    },
    hasAd: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: 0
    },
    dataList: {
      type: Array,
      default: () => []
    },
    trackDataNav: {},
    selectedList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    showFinalPrice: {
      type: Boolean,
      default: true
    },
    // 静默模式 没有动效
    silent: {
      type: Boolean,
      default: false
    },
    event: {
      type: String,
      default: 'operationClick'
    },
    lazy: {
      default: true,
      type: Boolean
    }
  },
  data() {
    return {
      swiperOption: {
        spaceBetween: 8,
        // slidesPerView: 3, // 不使用，滑动无边界
        slidesPerView: 'auto', // 不使用，滑动无边界
        // threshold: 20,
        freeMode: {
          enabled: false
          // momentumBounce: false,
          // sticky: false
        },
        // 设置点击箭头
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      activeData: {},
      thumbnailNum: 4, // 缩略图一行最小几个
      isShowFFSPriceFlag: false
    };
  },
  computed: {
    trackData() {
      // exposure_sequence 1
      const { index, trackDataNav } = this;
      const count = this.isMobile ? 2 : 3;
      const {
        navigation_primary_category,
        navigation_secondary_category,
        navigation_third_category
      } = trackDataNav;

      const exposureSequence =
        !this.isMobile && this.hasAd
          ? Math.ceil((index + 3) / count)
          : Math.ceil((index + 1) / count);
      const exposurePosition =
        !this.isMobile && this.hasAd ? (index + 3) % count : (index + 1) % count;

      const previousPageData = this.$previousPage.getPreviousPageData();

      return {
        ...previousPageData,
        navigation_primary_category,
        navigation_secondary_category,
        navigation_third_category,
        exposure_sequence: exposureSequence, // 上下
        exposure_position: exposurePosition || count, // 左右
        ...this.activeData.trackData
      };
    },
    // mediaLinkList() {
    //   const { mediaLinkList = [] } = this.activeData;
    //   return mediaLinkList;
    // },
    productList() {
      const { productList = [], spuColor = [] } = this.data;
      const list = productList.map((item, index) => {
        if (!Object.prototype.hasOwnProperty.call(item, 'isWished')) {
          // 如果对象没有 'isWished' 属性，就给它添加
          item.isWished = false;
        }
        const { mediaLink = '', mobileMediaLink = '', ...others } = item;

        const mobileMediaLinkList = (mobileMediaLink || mediaLink || '')
          .replace(/,http/g, '[http')
          .split('[');

        const mediaLinkList = (mediaLink || mobileMediaLink || '')
          .replace(/,http/g, '[http')
          .split('[');
        return {
          mediaLinkList: this.isMobile
            ? mobileMediaLinkList || mediaLink
            : mediaLinkList || mobileMediaLinkList,
          skuColor: spuColor && spuColor[index] ? spuColor[index]?.valueCode : null,
          skuColorIndex: spuColor && spuColor[index] ? index : null,
          ...others
        };
      });
      // fix
      // const filterOutStock = list.filter(item => item.inStock !== 0);
      const filterOutStock = list;
      return filterOutStock;
    },
    spuColor() {
      return this.data.spuColor || [];
    },
    tagList() {
      return this.data.mainTagList || [];
    },
    tagName() {
      return this.activeData.productCornerlabel || { text: '' };
    },
    elementStyle() {
      let paddingValue = 0;
      if (!this.isMobile) {
        paddingValue = 32;
      }
      return {
        'padding-bottom': `${paddingValue}px`
      };
    },
    getFinalPriceC() {
      return getFinalPrice(this.activeData);
      // FIXME
      // return {
      //   finalPrice: 12345,
      //   // 是否显示最终价
      //   isShowFinalPrice: true
      // };
    },
    getFFsPriceC() {
      return getFFsPrice(this.activeData);
    },
    displayImageList() {
      return this.activeData.mediaLinkList?.filter(i => !this.isVideoType(i)) || [];
    }
  },
  watch: {
    data: {
      handler(val) {
        this.activeData = val;
      },
      deep: true
    }
  },
  mounted() {
    this.activeData = this.data;
    this.activeData.skuColor = this.data.spuColor && this.data.spuColor[0]?.valueCode;
    this.activeData.skuColorIndex = 0;
    this.isShowFFSPriceFlag = localStorage.getItem('showFFSPrice') === 'true';
  },
  methods: {
    isVideoType,
    handleSelectProduct(data) {
      if (data.productCode === this.activeData.productCode) return;
      this.activeData = data;
      // this.handleSelectImg(0);
    }
  }
};
</script>

<style lang="scss" layout="pc">
.page-plp_product__lp-item {
  position: relative;
  // margin-bottom: 40px;
  // padding: 9px 10px 32px;
  border: 1px solid #fff;
  cursor: pointer;
  -webkit-touch-callout: none !important;
  /* 标准属性 */
  user-select: none;
  background: #fff;

  /* 为了兼容性添加各个浏览器的前缀 */
  -webkit-user-select: none; /* Safari 和 Chrome */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  -o-user-select: none; /* Opera */

  // .gt-image-container > div:first-child {
  //   transition: 1s all; //todo
  // }
  .lp-item__image-wraper {
    position: relative;
    .lp-item__image {
    }
    .lp-item__image-back {
      opacity: 0;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
    }
    &:hover .lp-item__image-back {
      opacity: 1;
    }
  }
  img {
    width: 100%;
  }
  .preview-img {
    &.fadeIn {
      opacity: 1;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
    }
  }
  &:hover {
    .spu-list .hover-box {
      visibility: visible;
      transition: 0.5s all;
    }
    // .spu-list {
    //   // max-height: 100vh;
    //   // overflow: visible;
    //   // transition: 0.5s all;
    //   z-index: 1;
    //   .hover-box {
    //     z-index: 1;
    //     opacity: 1;
    //     pointer-events: initial;
    //     .sp-plp-card__name {
    //       margin-top: 4px;
    //     }
    //   }
    // }

    .wish-icon {
      display: block;
    }
  }

  .wish-icon {
    width: 20px;
    height: 20px;
    position: absolute;
    right: 26px;
    top: 26px;
    display: none;
    cursor: pointer;
    z-index: 2;
  }

  .tag {
    position: absolute;
    left: 12px;
    top: 12px;

    z-index: 10;
  }

  .cancel-message {
    position: fixed;
    top: 50%;
    left: 50%;
    line-height: 22px;
    text-align: center;
    background: var(--darkgrey-60, rgba(20, 20, 30, 0.6));
    color: #fff;
    z-index: 9;
    transform: translate(-50%, -50%);
    border-radius: 1px;
    opacity: 0;
    display: none;
    padding: 12px 24px;
    gap: 12px;
    &.show {
      opacity: 1;
      display: block;
    }

    transition: all 0.5s;
  }

  .spu-list {
    // position: relative;
    // padding: 0px 30px 0px 12px;
    z-index: 1;
    position: relative;

    .hover-box {
      visibility: hidden;
      position: absolute;
      left: -11px;
      right: -11px;
      // top: 0px;
      bottom: -2px;
      padding: 0px 11px 0;
      // border-left: 1px solid var(--border-color-default);
      // border-right: 1px solid var(--border-color-default);
      // border-bottom: 1px solid var(--border-color-default);
      background: #fff;
      overflow: hidden;

      .sp-swiper-container {
        position: relative;
        // padding: 8px 16px;
        padding-left: 24px;
        padding-right: 24px;
        padding-top: 8px;
        padding-bottom: 8px;
        overflow: hidden;
        height: 86px;

        .swiper-wrapper {
          .swiper-slide {
            width: 56px !important;
            position: relative;
            cursor: pointer;
            // margin-right: 0 !important;
            // margin-left: 8px !important;

            .out-of-stock {
              background: rgba(240, 240, 240, 0.8);
              display: flex;
              align-items: center;
              justify-content: center;
              position: absolute;
              left: 0;
              right: 0;
              top: 0;
              bottom: 0;
              color: var(--main-color-ua-red, #dc0019);
              font-size: 14px;
              font-weight: 400;
              line-height: 20px;
            }
          }
        }
      }
      .active-border-bottom-line {
        border-bottom: 2px solid var(--main-color-ua-red, #dc0019);
        width: 100%;
        position: absolute;
        bottom: 0px;
      }
    }

    .swiper-button-prev,
    .swiper-button-next {
      background-color: rgba(0, 0, 0, 0);
      width: 16px;
      height: 16px;
      margin: -8px;
      padding-top: 12px;
      transition: none;
      &.swiper-button-disabled {
        display: none;
      }

      svg {
        width: 10px;
        // height: 16px;
      }

      &::after {
        color: var(--font-color-primary);
        font-size: 14px;
      }
    }

    .swiper-button-disabled {
      svg {
        opacity: 0.4;
      }

      display: flex;
    }
  }

  .sp-plp-card__color {
    display: flex;
    align-items: center;
    margin-top: 20px;
    margin-bottom: 16px;
    justify-content: center;
    .color-img {
      width: 8px;
      height: 8px;
      margin-right: 6px;
      display: block;

      &.white {
        border: 1px #979797 solid;
      }
    }

    span {
      color: var(--secondary-color-ua-cool-grey-04, #50505a);
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px;
    }
  }

  .sp-plp-card__name {
    font-size: 14px;
    font-weight: 600;
    color: var(--font-color-primary);
    line-height: 20px;
    margin: 24px 0px 8px 0;
    .product-name {
      text-align: left;
      -webkit-line-clamp: 2;
      max-height: 46px;
      line-height: 22px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      font-weight: 400;
      font-style: normal;
      font-family: PingFang SC;
      color: var(--main-color-ua-dark-grey, #14141e);
      font-size: 16px;

      &.one-line {
        -webkit-line-clamp: 1;
        height: 22px;
      }
    }
  }

  .sp-plp-card__price {
    display: flex;
    color: var(--secondary-color-ua-cool-grey-03, #8c8c96);

    font-family: Neue Plak;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;

    .product-price {
      text-decoration: line-through !important;
      // opacity: 0.5;
      margin: 0px 8px;
    }
    .is-line-through {
      color: var(--main-color-ua-dark-grey, #14141e);
    }
  }
  .sp-lp-card__final-price {
    display: flex;
    align-items: flex-end;
    .sp-lp-card__final-price-left {
      flex-grow: 1;
      .sale-price {
        color: var(--secondary-color-ua-cool-grey-03, #8c8c96);
        font-family: Neue Plak;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px;
        text-transform: uppercase;
        text-decoration: line-through !important;
        height: 22px;
        margin-bottom: 4px;
      }
      .final-price-text {
        color: var(--main-color-ua-dark-grey, #14141e);

        font-family: PingFang SC;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        text-transform: uppercase;
        height: 20px;
      }
    }
    .product-price {
      color: var(--main-color-ua-red, #dc0019);
      font-size: 20px;
      font-weight: 700;
    }
  }
  .sp-lp-card__salePoint {
    background: #fac800;
    line-height: 40px;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0px;
    text-align: center;
    color: #14141e;
    margin-top: 32px;
    display: none;
    span {
      position: relative;
      top: -1px;
    }
  }

  .promotion {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    height: 20px;
    overflow: hidden;
    margin-bottom: 4px;
    .sp-plp-card__promotion {
      color: var(--main-color-ua-red, #dc0019);
      font-family: PingFang SC;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px; /* 142.857% */
      text-transform: capitalize;
    }
    .sp-plp-card__selling {
      color: var(--secondary-color-ua-cool-grey-03, #8c8c96);

      /* cn/pingfang/regular/14 */
      font-family: PingFang SC;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px; /* 142.857% */
      text-transform: capitalize;
    }
    span {
      font-size: 14px;
      color: #dc0019;
      border-radius: 1px;
      line-height: 20px;
      height: 20px;
      max-width: 76px;
      display: block;
      -webkit-line-clamp: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-box-orient: vertical;
      &.promotion-item-1 {
        max-width: 100% !important;
      }
      &.has-num {
        max-width: 71px;
      }
      &.no-first {
        margin-left: 12px;
      }
    }
  }
  .color-block-dian {
    line-height: 8px;
    svg {
      margin-right: 4px;
      height: 4px;
      width: 4px;
    }
  }
  .ua-image {
    background: #f0f0f0;
  }

  // -----------------------
  .spu-list .swiper-button-next {
    width: 24px;
    height: 100%;
    background: #fff;
    z-index: 1;
    opacity: 1;
    border-radius: 0;
    top: 50%;
    transform: translateY(-50%);
    padding: 0;
    margin: 0px;
    right: 0;
    justify-content: flex-end;

    svg {
      top: 50%;
      margin-top: 12px;
      transform: translateY(-50%);
    }
  }
  .spu-list .swiper-button-prev {
    width: 24px;
    height: 100%;
    background: #fff;
    z-index: 1;
    opacity: 1;
    border-radius: 0;
    top: 50%;
    transform: translateY(-50%);
    padding: 0;
    margin: 0px;
    left: 0;
    justify-content: flex-start;

    svg {
      top: 50%;
      margin-top: 12px;
      transform: translateY(-50%);
    }
  }
  .one-img:hover img {
    transition: transform 0.7s ease;
    transform: scale(1.1);
  }
  .mobile-press-mask {
    flex-direction: column; /* 垂直排列元素 */

    align-items: center;
    background: var(--darkgrey-60, rgba(20, 20, 30, 0.6));
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    text-align: center;
    color: white; /* 遮罩层上的文字颜色 */
    display: flex;
    padding: 16px 0 20px;
    z-index: 10;
    .mpm-title {
      color: var(--main-color-ua-white, #fff);
      text-align: center;

      /* cn/pingfang/regular/12 */
      font-family: PingFang SC;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px; /* 150% */
      text-transform: capitalize;
    }
    .mpm-circle {
      width: 48px;
      height: 48px;
      flex-shrink: 0;
      fill: var(--white-30, rgba(255, 255, 255, 0.3));
      backdrop-filter: blur(10px);
      margin-top: 31px;
      position: relative;
      .mpm-circle-svg {
        width: 48px;
        height: 48px;
        flex-shrink: 0;
      }
      .mpm-circle-icon-svg {
        width: 24px;
        height: 24px;
        position: absolute;
        left: 12px;
        top: 12px;
      }
      .circle-button {
        position: absolute;
        width: 100%;
        left: 0;
        top: 60px;
        color: var(--main-color-ua-white, #fff);
        text-align: center;

        /* cn/pingfang/regular/14 */
        font-family: PingFang SC;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 142.857% */
        text-transform: capitalize;
      }
    }
    .circle-button-2 {
      position: absolute;
      bottom: 20px;
      color: var(--main-color-ua-white, #fff);
      text-align: center;

      /* cn/pingfang/bold/12 */
      font-family: PingFang SC;
      font-size: 12px;
      font-style: normal;
      font-weight: 600;
      text-transform: uppercase;
      height: 28px;
      border: 0.5px solid var(--main-color-ua-white, #fff);
      line-height: 28px;
      padding: 0 12px;
      border-radius: 1px;
    }
  }
  .mobile-press-mask2 {
    flex-direction: column; /* 垂直排列元素 */

    align-items: center;
    background: var(--darkgrey-60, rgba(20, 20, 30, 0.6));
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    text-align: center;
    color: white; /* 遮罩层上的文字颜色 */
    display: flex;
    justify-content: center;

    .mpm-circle {
      width: 48px;
      height: 48px;
      fill: var(--white-30, rgba(255, 255, 255, 0.3));
      backdrop-filter: blur(10px);
      position: relative;
      .mpm-circle-svg {
        width: 48px;
        height: 48px;
        flex-shrink: 0;
      }
      .mpm-circle-icon-svg {
        width: 24px;
        height: 24px;
        position: absolute;
        left: 12px;
        top: 12px;
      }
      .circle-button {
        position: absolute;
        width: 100%;
        left: 0;
        top: 60px;
        color: var(--main-color-ua-white, #fff);
        text-align: center;

        /* cn/pingfang/regular/14 */
        font-family: PingFang SC;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 142.857% */
        text-transform: capitalize;
      }
    }
  }
}
</style>
<style lang="scss" layout="mobile">
.page-layout_mobile {
  .product-list-columns-3 {
    .page-plp_product__lp-item {
      .sp-plp-card__color {
        span {
          &:nth-child(3) {
            display: none;
          }
          &:nth-child(4) {
            display: none;
          }
        }
      }
    }
  }
  .page-plp_product__lp-item {
    position: relative;
    // margin-bottom: 16px;
    padding: 0px 0px 14px 0px;
    border: 0px;
    cursor: pointer;

    &:hover {
      border: 0px;
    }
    .sp-plp-card__color {
      display: flex;
      align-items: center;
      margin-top: 12px;
      margin-bottom: 12px;
      justify-content: center;
      padding: 0px 16px;
      .color-img {
        height: 4px;
        margin-right: 4px;

        &.white {
          border: 1px #979797 solid;
        }
      }

      span {
        color: var(--secondary-color-ua-cool-grey-04, #50505a);
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px;
      }
    }
    .sp-plp-card__name,
    .sp-plp-card__price,
    .promotion {
      // padding: 0px 16px;
      span {
        // padding: 0px 4px;
        max-width: 70px;
        &.promotion-item-1 {
          max-width: 100%;
        }
        &.has-num {
          max-width: 62px;
        }
      }
    }
    .sp-lp-card__salePoint {
      height: 24px;
      line-height: 24px;
      margin-top: 8px;
      font-size: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      display: none;
      span {
        transform-origin: center center;
        transform: scale(0.98);
      }
    }

    .sp-plp-card__name {
      margin-bottom: 4px;
      margin-top: 8px;

      .product-name {
        text-align: left;
        -webkit-line-clamp: 2;
        max-height: 36px;
        line-height: 18px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        font-family: PingFang SC;
        color: var(--main-color-ua-dark-grey, #14141e);

        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        text-transform: capitalize;
        height: 36px;
      }
    }
    .promotion {
      height: 18px;
      line-height: 18px;
      .sp-plp-card__promotion {
        color: var(--main-color-ua-red, #dc0019);
        font-family: PingFang SC;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px; /* 150% */
        text-transform: capitalize;
      }
      .sp-plp-card__selling {
        color: var(--secondary-color-ua-cool-grey-03, #8c8c96);
        font-family: PingFang SC;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px; /* 150% */
        text-transform: capitalize;
      }
      span {
        font-size: 12px;
        color: #dc0019;
        border-radius: 1px;
        line-height: 18px;
        height: 18px;
        max-width: 76px;
        display: block;
        -webkit-line-clamp: 1;
        overflow: hidden;
        // word-break: keep-all;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        &.promotion-item-1 {
          max-width: 100% !important;
        }
        &.has-num {
          max-width: 71px;
        }
        &.no-first {
          margin-left: 8px;
        }
      }
    }
    .sp-plp-card__price {
      line-height: 18px;
      height: 18px;
      margin-bottom: 4px;

      color: var(--secondary-color-ua-cool-grey-03, #8c8c96);
      font-family: Neue Plak;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      span {
        padding: 0px;
      }
      .product-price {
        margin-left: 4px;
      }
    }

    .sp-lp-card__final-price {
      flex-wrap: wrap;
      .sp-lp-card__final-price-left {
        flex-shrink: 0;
      }
      .final-price-text {
        font-size: 10px;
      }
      .sale-price {
        font-size: 12px;
        margin-bottom: 0px;
      }
      .product-price {
        font-size: 14px;
        margin-top: 0px;
      }
    }

    .wish-icon {
      right: 8px;
      top: 8px;
      display: block;
    }

    .tag {
      left: 8px;
      top: 8px;
    }

    .cancel-message {
      position: fixed;
    }
    .color-block-dian {
      line-height: 4px !important;
      svg {
        margin-right: 2px !important;
        height: 2px;
        width: 2px;
      }
    }
  }
}
</style>
